import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class GroupService {
  groupAction = new Subject();

  constructor(private httpClient: HttpClient) { }

  create(form): Observable<any> {
    let did = form.dashboardId;
    let body = form;
    return this.httpClient.post('private-dashboard/' + did + '/group', body);
  }

  list(dashboardId, filter = ""): Observable<any> {
    if (filter != "") {
      filter = "&" + filter;
    }
    return this.httpClient.get<any>('private-dashboard/' + dashboardId + '/group?sort=order-asc' + filter);
  }

  getAction(): Observable<any> {
    return this.groupAction.asObservable();
  }

  sendAction(action, data) {
    return this.groupAction.next({ action: action, data: data });
  }

  delete(did, gid) {
    return this.httpClient.delete('private-dashboard/' + did + '/group/' + gid);
  }

  update(form) {
    let did = form.dashboardId;
    let body = form;
    return this.httpClient.patch('private-dashboard/' + did + '/group', body);
  }

  filter(form, did): Observable<any> {
    let body = form;
    return this.httpClient.post('private-dashboard/' + did + '/group/filter', body);
  }

  getGeoSegments(): Observable<any> {
    return this.httpClient.get<any>('geosite/segments');
  }

  getCategoryList(): Observable<any> {
    return this.httpClient.get<any>('geosite/getCategories');
  }

  getSubCategoryList(catId): Observable<any> {
    return this.httpClient.get<any>('geosite/getCategories/' + catId);
  }

  addGeoSite(form): Observable<any> {
    return this.httpClient.post('geosite/add', form);
  }

  deleteGeoSite(catId): Observable<any> {
    return this.httpClient.post<any>('geosite/delete', catId);
  }

  getGeoSiteList(): Observable<any> {
    return this.httpClient.get<any>('geosite/geoSitelist');
  }

  reGenrateView(siteId): Observable<any> {
    return this.httpClient.post<any>('geosite/generateView', siteId);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/group/group.service.ts